import { render, staticRenderFns } from "./UTableProjectAnalytics.vue?vue&type=template&id=5a3a64c4&scoped=true&"
import script from "./UTableProjectAnalytics.vue?vue&type=script&lang=js&"
export * from "./UTableProjectAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a64c4",
  null
  
)

export default component.exports